import RecipeList from './recipe_list'

export default RecipeList
